import React from 'react';
import '../assets/css/basic_page.css'


class Pages extends React.Component {

  constructor(props) {
    super(props);
    this.firstRef = React.createRef();
    this.secondRef = React.createRef();
    this.thirdRef = React.createRef();
    this.fourthRef = React.createRef();
    this.fifthRef = React.createRef();
    this.sixthRef = React.createRef();
    this.seventhRef = React.createRef();
    this.eighthRef = React.createRef();

    this.refRef = React.createRef();
  }

  scroll = (ref) => {
    if (ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop - 61,
        behavior: 'smooth',
      });
    }
  };

  leftmenu = () => {
    return (
      <>Not implemented</>
    )
  }
  righttext = () => {
    return (
      <>Not implemented</>
    )
  }


}


export default Pages;

